import { MultiProviderConfig, ShopType, CheckoutType } from 'types';
import { asyncEligible } from 'config';
import { ProviderConfigList } from 'config/providers';
import { ApartmentListTheme } from 'config/themes';

export const ApartmentList: MultiProviderConfig = {
  name: 'ApartmentList',
  micrositeCode: 'ApartmentList',
  displayName: 'Apartment List',
  enableMicrositeLanding: true,
  shopType: ShopType.MULTI_PROVIDER,
  domain: 'updater.com',
  homepage: 'https://apartmentlist.updater.com/',
  title: 'Apartment list Internet Shopping',
  fallbackPhoneNumber: '877-657-5508',
  fallbackLeadModePhoneNumber: '877-657-5508',
  defaultCheckoutType: CheckoutType.LEAD_MODE,
  defaultTheme: ApartmentListTheme,
  needsDcSession: false,
  updaterCrossSellActive: false,
  source: 'ApartmentList',
  noOffersRetry: 2,
  qualOnLoad: {
    hostname: 'apartmentlist.updater.com',
    promoId: '5002970',
  },
  providers: ProviderConfigList,
  getCheckoutType: asyncEligible,
  movingAppBuyflowUrls: {
    development: 'http://localhost:3000/guest/tvi/buy',
    staging: 'https://staging-apartmentlist.updater.com/guest/tvi/buy',
    qa: 'https://staging-apartmentlist.updater.com/guest/tvi/buy',
    production: 'https://apartmentlist.updater.com/guest/tvi/buy',
  },
};
